import "./AboutUs.css"
import AboutUsHero from "./AboutUsHero/AboutUsHero";
import AboutUsSection from "./AboutUsSection/AboutUsSection"
import SEO from "../../components/SEO/SEO";


function AboutUs() {
    return ( 
    <div className="about-us-container">

           <>
              <SEO
                title="Über uns | Fit2Clean"
                description="Erfahren Sie mehr über unser Team."
                canonical="https://www.fit-to-clean.de/about-us"
              />

        <div className="about-us-hero">
            <AboutUsHero
            eyebrow="Über uns"
            title="Fit2Clean – Ihr Partner für saubere Arbeitswelten"
            text="Seit vielen Jahren betreuen wir Büros, Praxen und gewerblich genutzte Flächen im Raum München. Unser Fokus liegt auf verlässlicher Unterhaltsreinigung, klaren Abläufen und persönlicher Betreuung."
            portraitSrc="/pictures/object manager.jpg"
            portraitAlt="Objektleiterin von Fit2Clean"
            name="Amira Schweiger"
            role="Betriebsleiterin"
            />
        </div>

        <div className="about-us-section">
             <AboutUsSection
                eyebrow="Wer wir sind"
                title="Ein Team mit Blick fürs Detail"
                text="Fit2Clean verbindet Erfahrung in der Gebäudereinigung mit einem hohen Qualitätsanspruch. Unsere Teams arbeiten nach klaren Reinigungsplänen und festen Zuständigkeiten – so wissen Sie immer, wer für Ihr Objekt verantwortlich ist."
                imageSrc="/pictures/clean-blue-glove.jpg"
                imageAlt="Team von Fit2Clean bei der Arbeit"
            />

            <AboutUsSection
                eyebrow="Arbeitsweise"
                title="Planbare Abläufe, transparente Kommunikation"
                text="Wir stimmen Intervalle, Zeiten und Leistungen genau auf Ihren Betrieb ab. Ob Reinigung außerhalb der Geschäftszeiten oder spezielle Anforderungen: Sie erhalten eine Lösung, die sich nahtlos in Ihren Alltag integriert."
                imageSrc="/pictures/clean-planning.jpg"
                imageAlt="Strukturierte Reinigungsplanung"
                reverse
            />

            <AboutUsSection
                eyebrow="Anspruch"
                title="Sauberkeit als Teil Ihres Auftritts"
                text="Saubere Räume sind mehr als nur angenehm – sie wirken nach innen und außen. Mit gepflegten Arbeitsplätzen, Eingangsbereichen und Sanitärflächen unterstützen wir das professionelle Erscheinungsbild Ihres Unternehmens."
                imageSrc="/pictures/clean-modern-office.jpg"
                imageAlt="Sauberes Büro"
            />

        </div>

          </>
    </div> 
    );
}

export default AboutUs;